import media from '@/styles/media';
import theme from '@/styles/theme';
import styled from 'styled-components';

export const EmailBox = styled.div`
  font-size: 17px;
  color: ${theme.color.black};
  font-family: ${theme.fontFamily.regular};
  background-color: ${theme.color.white};
  border-radius: 15px;
  box-shadow: 0px 3px 3px #00000029;
  border: 1px solid ${theme.color.disabled};
  height: 100px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.md`
    font-size: 15px;
    height: 80px;
  `}
`;
